import { useTranslation } from 'react-i18next'
import { useGetBlobsHook, type EasySearchHitDto } from '@dhl/mdp-api'
import { CardAccordion, H6, List, ListItem, ListItemIcon, ListItemText, Paper } from '@dhl-ui/components'
import { ImportIcon } from '@dhl-ui/icons'
import { useBlobPaths } from '../hooks/useBlobMapping'
import { downloadAnything } from '~/common/util/download'
import { useNotificationMessage } from '~/common/hooks/useNotificationMessage'

type Props = {
  hits: EasySearchHitDto[]
}

export const PppDownloads = ({ hits = [] }: Props) => {
  const getBlobs = useGetBlobsHook()
  const { t } = useTranslation()
  const { hasBlobPaths, blobPaths } = useBlobPaths(hits)
  const { showError } = useNotificationMessage()

  const downloadBlob = async (fileName: string, blobPath: string) => {
    return getBlobs({ filePath: blobPath })
      .then((blob) => {
        downloadAnything(fileName, blob, blob.type)
      })
      .catch(() => {
        showError(t('admin.pppPage.hits.downloadFailed', { fileName }))
      })
  }

  return hasBlobPaths ? (
    <Paper>
      <CardAccordion
        title={t('admin.pppPage.hits.downloads')}
        summary={t(
          blobPaths.length === 1 ? 'admin.pppPage.hits.singleDownload' : 'admin.pppPage.hits.multipleDownloads',
          { count: blobPaths.length }
        )}
      >
        <CardAccordion.Content>
          <List>
            {blobPaths.map(({ blobPath, fileName }, i) => (
              <ListItem
                key={fileName}
                isButton
                onClick={() => downloadBlob(fileName, blobPath)}
                hasDivider={i > 0}
                aria-label={`${t('admin.pppPage.hits.download')} ${fileName}`}
              >
                <ListItemIcon>
                  <ImportIcon />
                </ListItemIcon>

                <ListItemText primary={fileName}>
                  <H6
                    variant="dhlRed"
                    component="div"
                    sx={{
                      mt: 1,
                    }}
                  >
                    {t('admin.pppPage.hits.download')}
                  </H6>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </CardAccordion.Content>
      </CardAccordion>
    </Paper>
  ) : null
}
